module.exports = __webpack_public_path__ + "media/assets/images/report_fr-3c31ec2f621dcba2a07072d910d07d42.png";